import React from 'react';

export type PanelProps = {
  activeIndex: number;
  children: React.ReactNode;
  index: number;
};

const Panel = ({ activeIndex, children, index }: PanelProps) => {
  return <>{activeIndex === index && children}</>;
};

export default Panel;
